"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormGroup["default"];
  }
});
var _FormGroup = _interopRequireDefault(require("react-bootstrap/lib/FormGroup"));


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/FormGroup.js
// module id = 6399
// module chunks = 25